/* eslint-disable linebreak-style */
import React from 'react'
import { handleFacebookCallback } from '../../utils/OAuthCallback/handleOAuthCallback'
import { Button, Image, Box } from '@chakra-ui/react'
import FacebookImg from '../../Assets/Images/facebook-logo.svg'

const FacebookButton = (): JSX.Element => {
  const handleClickButton = (): void => {
    handleFacebookCallback()
  }

  const buttonStyles = {
    border: '1px solid #787579',
    paddingInline: '5px',
    display: 'flex',
    justifyContent: 'center',
    gap: 4,
    fontSize: 14,
    w: '190px',
    h: '50px',
  }

  const imgStyles = {
    w: '30px',
    mr: -2,
  }

  return (
    <Button onClick={handleClickButton} sx={{ ...buttonStyles, width: '205px' }} className="socialButton">
      <Image src={FacebookImg} alt="facebook logo" sx={imgStyles} fallbackSrc="https://via.placeholder.com/48" borderRadius="full" />
      <Box sx={{ color: '#1877F2' }}>Sign in with Facebook</Box>
    </Button>
  )
}

export default FacebookButton
